import * as React from "react";

interface IErrorListProps {
    mapErrors: Array<string>;
}

const ErrorList = ({ mapErrors }: IErrorListProps) => {
    const errorList = mapErrors.map(function (err) {
        return <div className="error-item">{err}</div>;
    });
    return (
        <div className="error-list">
            {errorList}
        </div>);

}

export default ErrorList;
